import {Form, Tag as AntdTag} from "../../../__snowpack__/pkg/antd.js";
import Text from "../../../__snowpack__/pkg/antd/lib/typography/Text.js";
import classNames from "../../../__snowpack__/pkg/classnames.js";
import {isBoolean, isFunction, isNumber, isString} from "../../../__snowpack__/pkg/lodash.js";
import React, {useContext} from "../../../__snowpack__/pkg/react.js";
import {TagsContext} from "./TagsContext.js";
export default function Tag(props) {
  const {searchType, searchMode} = useContext(TagsContext);
  const {name, label, className, visible = name ? void 0 : true, multiple, transfer, ...restProps} = props;
  return /* @__PURE__ */ React.createElement(Form.Item, {
    shouldUpdate: () => searchMode === "collapse" || searchType !== "advance",
    noStyle: true
  }, (form) => {
    const value = name ? form.getFieldValue(name) : void 0;
    const values = form.getFieldsValue(true);
    let _visible;
    if (isFunction(visible)) {
      _visible = visible(value, values);
    } else if (isBoolean(visible)) {
      _visible = visible;
    } else if (isBoolean(value) || value === 0) {
      _visible = true;
    } else {
      _visible = !!value;
    }
    let tagValues = [value];
    if (multiple && Array.isArray(value)) {
      tagValues = value;
    }
    if (!_visible) {
      return null;
    }
    if (multiple && !tagValues?.length) {
      return null;
    }
    let closable = true;
    if (!name || isBoolean(value)) {
      closable = false;
    }
    let _label = label;
    if (isFunction(label)) {
      _label = label(value, values);
    }
    return /* @__PURE__ */ React.createElement("span", {
      className: "search-form-tag-wrapper"
    }, (_label || name) && /* @__PURE__ */ React.createElement("span", {
      className: "search-form-tag-label"
    }, `${_label ?? name}:`), tagValues.map((_value, index) => {
      const tagValue = transfer?.(_value, values) ?? _value;
      return /* @__PURE__ */ React.createElement(AntdTag, {
        className: classNames("search-form-tag", className),
        closable,
        ...restProps,
        visible: _visible,
        onClose: () => {
          restProps.onClose?.(form);
          if (name) {
            if (multiple && Array.isArray(value)) {
              value.splice(index, 1);
              form.setFields([{name, value: value.length === 0 ? void 0 : [...value]}]);
            } else {
              form.setFields([{name, value: void 0}]);
            }
            form.submit();
          }
        }
      }, isNumber(tagValue) || isString(tagValue) ? /* @__PURE__ */ React.createElement(Text, {
        style: {maxWidth: 240},
        ellipsis: {tooltip: true}
      }, tagValue) : tagValue);
    }));
  });
}
